import axios from 'axios';
import misc from './misc';

const checkSSO = () => {
  const infoKey = misc.getParameterByName('infoKey');
  return new Promise((resolve, reject) => {
    if (!infoKey) {
      resolve();
      return;
    }

    // @: 忽略localStorage中已经存储的登录信息
    // @: 既然忽略localStorage中已有信息，那么先清空试试，猜测处理
    const lang = localStorage.locale;
    localStorage.clear();
    localStorage.locale = lang;
    axios.get(`/permissionManagment/permit/sso/info?infoKey=${infoKey}`).then((res) => {
      if (!res || !res.data || !res.data.result) {
        const msg = 'Login error: no api result.';
        console.error(msg);
        reject(msg);
        return;
      }

      const loginInfo = res.data.result;
      // @:block流程的登录信息
      if (!loginInfo.token) {
        const msg = 'Login error: no token has benn found.';
        console.error(msg);
        reject(msg);
        return;
      }
      if (!loginInfo.info) {
        const msg = 'Login error: no user info has benn found.';
        console.error(msg);
        reject(msg);
        return;
      }
      if (!loginInfo.info.id) {
        const msg = 'Login error: invalid user id.';
        console.error(msg);
        reject(msg);
        return;
      }
      if (!loginInfo.enterprise) {
        const msg = 'Login error: invalid enterprise.';
        console.error(msg);
        reject(msg);
        return;
      }
      if (!loginInfo.orgId) {
        const msg = 'Login error: invalid org id.';
        console.error(msg);
        reject(msg);
        return;
      }
      localStorage.setItem('token', loginInfo.token);
      localStorage.setItem('userInfo', JSON.stringify(loginInfo.info));
      localStorage.setItem('enterprise', loginInfo.enterprise);
      localStorage.setItem('orgId', loginInfo.orgId);

      // @:仅打出错误日志的登录信息
      if (!loginInfo.licenseInfo) {
        const msg = 'Login error: no license info has been found.';
        console.error(msg);
      }
      if (!loginInfo.orgListInfo) {
        const msg = 'Login error: no organizations has been found.';
        console.error(msg);
      }
      if (!loginInfo.orgProductList) {
        const msg = 'Login error: no org-products has been found.';
        console.error(msg);
      }
      if (!loginInfo.userProductList) {
        const msg = 'Login error: no user-products has been found.';
        console.error(msg);
      }
      if (!loginInfo.privileges) {
        const msg = 'Login error: no privilege info has been found.';
        console.error(msg);
      }
      if (!loginInfo.enterpriseInfo) {
        const msg = 'Login error: no enterpirse info has been found.';
        console.error(msg);
      }
      localStorage.setItem('licenseInfo', JSON.stringify(loginInfo.licenseInfo));
      localStorage.setItem('orgAllList', JSON.stringify(loginInfo.orgListInfo));
      localStorage.setItem('setProduct', JSON.stringify(loginInfo.orgProductList));
      localStorage.setItem('products', JSON.stringify((loginInfo.userProductList || []).map((v) => {
        v.toModule = v.code;
        v.toRoute = v.route;
        return v;
      })));
      localStorage.setItem('userPrivilege', JSON.stringify(loginInfo.privileges));
      localStorage.setItem('enterpriseInfo', JSON.stringify(loginInfo.enterpriseInfo));
      // @:仅打出告警日志的登录信息: 在BF以外的产品中，不需要传入appid即可跳转
      if (!loginInfo.appId) {
        const msg = 'Login warn: no appid has been found.';
        console.warn(msg);
      }
      if (!loginInfo.robotName) {
        const msg = 'Login warn: no robot name has been found.';
        console.warn(msg);
      }
      if (!loginInfo.robotInfo) {
        const msg = 'Login warn: no robot info has been found.';
        console.warn(msg);
      }
      if (loginInfo.appId) {  // @:由于配合KM修改取消了appid的强制校验逻辑，所以需要就加入此判断，避免localStorage.appid被设置成'null'
        localStorage.setItem('appid', loginInfo.appId);
        localStorage.setItem('robotName', loginInfo.robotName);
        localStorage.setItem('robots', JSON.stringify([loginInfo.robotInfo]));  // @:2021.5.19新增
      }
      // @:无需错误提示的登录信息
      // eslint-disable-next-line max-len
      // localStorage.setItem('locale', loginInfo.locale);  // @:未设置语言时, 后端会返回中文; 此机制会让前端的自动语言识别失效, 因此删除此逻辑
      localStorage.setItem('currentRoute', window.location.hash.split('#/').pop().split('?').shift());
      const tmp = window.location.search.split('?');
      const queryString = tmp.pop().split('&').filter(item => !item.startsWith('infoKey=')).join('&');
      debugger;
      // @:有重定向地址时, 清除url中的infoKey参数, 避免每次请求都请求SSO信息
      if (loginInfo.redirectUrl) {
        // resolve(); // @:注意！这行代码不能要，会触发进入login页面时清除所有localStorage数据的逻辑
        window.location.href = `${loginInfo.redirectUrl}?${queryString}`;
        return;
      }
      // @:没有重定向地址时跳转到机器人列表
      // resolve(); // @:注意！这行代码不能要，会触发进入login页面时清除所有localStorage数据的逻辑
      window.location.href = `/bf/#/manage/robot-manage?${queryString}`;
    }).catch(reject);
  });
};
export default checkSSO;



// WEBPACK FOOTER //
// ./src/utils/js/checkSSO.js